import axios from 'axios';

const api = axios.create({
  // Base URL de tu backend (usamos localhost como lo solicitaste) 
  baseURL: 'https://backmedical.astrobiker.com/api', 
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Interceptor: Inyecta el token en cada petición (excepto el login, que no lo necesita)
api.interceptors.request.use(
  (config) => {
    // Recupera el token del localStorage
    const token = localStorage.getItem('laravel_auth_token'); 

    // Si existe un token, lo añade al encabezado 'Authorization'
    if (token) {
      // Uso de la sintaxis estándar para Bearer Token
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;